import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { assets } from '../../core/constants/assets.const';
import { SharedModule } from '../../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDialog } from '@angular/material/dialog';
import { SyncCalenderComponent } from '../../modals/sync-calender/sync-calender.component';
import { SearchModule } from '../../shared/components/search/search.module';
import { AuthService } from '../../services/auth.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { UserResponse } from '../../models/auth.model';
import { BaseClass } from '../../shared/class/baseClass';
import { environment } from '../../../environments/environment';
import { UserRole } from '../../core/constants/keys.constant';

@Component({
  selector: 'mindbase-main',
  standalone: true,
  imports: [MatSidenavModule, MatIconModule, MatMenuModule, CommonModule, RouterModule, SharedModule, TranslateModule, MatBadgeModule, SearchModule],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent extends BaseClass implements OnInit, OnDestroy {
  private destroy: Subject<boolean> = new Subject<boolean>();
  protected subscriptionSubject$!: Subscription;
  protected profile: UserResponse | null = null;
  public assets = assets;
  public sidenavWidth = 200;
  protected url: any;
  protected currentPath: 'tutorCounselor' | 'studentParent' = 'studentParent';
  protected userRole = UserRole;
  constructor(injector: Injector, public _authService: AuthService, private dialog: MatDialog) {
    super(injector);
  }

  ngOnInit(): void {
    this.subscriptionSubject$ = this._authService.profileDetailsSubject
      .pipe(takeUntil(this.destroy))
      .subscribe((res: UserResponse | null) => {
        if (res !== null) {
          this.profile = res;
          if (this.profile.role === UserRole.TUTOR || this.profile.role === UserRole.COUNSELOR) {
            this.currentPath = 'tutorCounselor';
          } else {
            this.currentPath = 'studentParent';
          }
        } else {
          if (localStorage.getItem(environment.storageKey)) {
            this.getProfile();
          }
        }
      });
  }

  getProfile(): void {
    this._spinnerService.addToLoader('getProfile');
    this._authService
      .getProfile()
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (res: UserResponse) => {
          this._spinnerService.removeFromLoader('getProfile');
          this.profile = res;
          if (this.profile.role === UserRole.TUTOR || this.profile.role === UserRole.COUNSELOR) {
            this.currentPath = 'tutorCounselor';
          } else {
            this.currentPath = 'studentParent';
          }
          this._authService.profileDetailsSubject.next(res);
        },
        error: () => {
          this._spinnerService.removeFromLoader('getProfile');
        }
      });
  }

  handleRouteNavigation(): void {
    if (this.profile?.role === UserRole.STUDENT || this.profile?.role === UserRole.PARENT) {
      this.router.navigate(['/my-profile']);
    } else if (this.profile?.role === UserRole.TUTOR || this.profile?.role === UserRole.COUNSELOR) {
      this.router.navigate(['/tutor/profile']);
    }
  }

  toggleSidenav(): void {
    this._authService.toggleSidebarView();
  }
  syncCalender(): void {
    const dialogRef = this.dialog.open(SyncCalenderComponent, {});
    dialogRef.afterClosed().subscribe(() => { });
  }

  ngOnDestroy(): void {
    this.destroy.complete();
    this.destroy.unsubscribe();
  }
}
